import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import store from "@/store";

// Récupérer la valeur de darkmode depuis le store
const fontSize = 10;

// Variable pour stocker l'ID de l'intervalle

export default /*#__PURE__*/_defineComponent({
  __name: 'Background',
  setup(__props) {

const darkmode = ref(store.state.darkMode);

const backgroundColor = ref<string>("rgba(33, 33, 33, 0.1)"); // Valeur par défaut (mode sombre)
const letterColor = ref<string>("rgba(236, 236, 236, 1)"); // Valeur par défaut (mode sombre)

// Fonction pour générer une couleur aléatoire dans les nuances de noir
const getRandomBlackShade = () => {
  const alpha = Math.random() * 0.3 + 0.7; // Nuance de noir semi-transparente (0.7 à 1)
  return `rgba(33, 33, 33, ${alpha.toFixed(2)})`;
};

// Fonction pour générer une couleur aléatoire dans les nuances de blanc
const getRandomWhiteShade = () => {
  const alpha = Math.random() * 0.3 + 0.7; // Nuance de blanc semi-transparente (0.7 à 1)
  return `rgba(236, 236, 236, ${alpha.toFixed(2)})`;
};

// Référence du canvas et contexte
const canvas = ref<HTMLCanvasElement | null>(null);
const ctx = ref<CanvasRenderingContext2D | null>(null);

// Tableau de lettres pour l'animation
const letters =
  "ABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZアカサタナハマヤラワガザダバパイキシチニヒミリヰギジヂビピウクスツヌフムユルグズヅブプエケセテネヘメレヱゲゼデベペオコソトノホモヨロヲンゴゾドボポ0123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789".split(
    ""
  );

// Taille de la police
let intervalId: number | null = null;

// Fonction pour ajuster la taille du canvas
const resizeCanvas = () => {
  if (canvas.value) {
    const width = window.innerWidth;
    const height = window.innerHeight;

    // Si la taille du canvas a changé, on redémarre l'animation
    if (canvas.value.width !== width || canvas.value.height !== height) {
      canvas.value.width = width;
      canvas.value.height = height;

      // Redémarrer l'animation après le redimensionnement
      startMatrixEffect();
    }
  }
};

// Fonction pour démarrer l'animation
const startMatrixEffect = () => {
  if (canvas.value) {
    // Initialisation du contexte du canvas
    ctx.value = canvas.value.getContext("2d");
    if (!ctx.value) return;

    // Initialisation des colonnes
    const columns = Math.floor(canvas.value.width / fontSize);
    const drops = Array(columns).fill(1);

    // Fonction de dessin de l'animation
    const draw = () => {
      if (ctx.value && canvas.value) {
        // Effet de fondu
        ctx.value.fillStyle = backgroundColor.value;
        ctx.value.fillRect(0, 0, canvas.value.width, canvas.value.height);

        // Dessin des lettres
        for (let i = 0; i < drops.length; i++) {
          const text = letters[Math.floor(Math.random() * letters.length)];
          ctx.value.fillStyle = darkmode.value
            ? getRandomWhiteShade() // Couleur aléatoire dans les nuances de #212121
            : getRandomBlackShade(); // Couleur aléatoire dans les nuances de blanc
          ctx.value.fillText(text, i * fontSize, drops[i] * fontSize);

          // Faire tomber les lettres
          drops[i]++;
          if (
            drops[i] * fontSize > canvas.value.height &&
            Math.random() > 0.95
          ) {
            drops[i] = 0;
          }
        }
      }
    };

    // Nettoyer l'intervalle existant avant de démarrer un nouveau
    if (intervalId) {
      clearInterval(intervalId);
    }

    // Appeler la fonction de dessin toutes les 33 ms
    intervalId = setInterval(draw, 33);
  }
};

// Mettre à jour les couleurs en fonction du mode
const updateColors = () => {
  if (darkmode.value) {
    backgroundColor.value = "rgba(33, 33, 33, 0.1)"; // Mode sombre : fond noir avec opacité
    letterColor.value = "rgba(236, 236, 236, 1)"; // Couleurs de lettres en nuances de blanc
  } else {
    backgroundColor.value = "rgba(236,236,236,0.1)"; // Mode clair : fond gris clair
    letterColor.value = "rgba(33, 33, 33, 1)"; // Couleurs de lettres en nuances de noir
  }
};

// Watcher pour surveiller les changements du mode sombre
watch(
  () => store.state.darkMode,
  (newValue) => {
    darkmode.value = newValue;
    updateColors(); // Mettre à jour les couleurs lorsque le mode change
  }
);

// Nettoyer l'intervalle lorsque le composant est détruit
onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
});

// Utiliser `onMounted` pour démarrer l'animation après le montage
onMounted(() => {
  // Ajouter un écouteur d'événements pour gérer le redimensionnement de la fenêtre
  window.addEventListener("resize", resizeCanvas);
  resizeCanvas();
  startMatrixEffect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("canvas", {
    ref_key: "canvas",
    ref: canvas,
    class: "matrix-canvas"
  }, null, 512))
}
}

})